export default {
  isLoading: false,
  isDownloadLoading: false,
  siniestros: [],
  siniestrosWithFilter: [],
  totalSiniestros: 0,
  filtrosSiniestros: null,
  selectedSiniestro: {},
  atencionesMedicas: [],
  showNoDataAtencionesMedicasEmpresa: false,
  periodosReposo: [],
  showNoDataPeriodosReposoEmpresa: false,
  evaluacionesIncapa: [],
  showNoDataEvaluacionesIncapaEmpresa: false,
  prestacionesEconomicas: [],
  showNoDataPrestacionesEconomicasEmpresa: false,
  denuncias: [],
  showNoDataDenunciasEmpresa: false,
  successTagManager: false,
};
